jQuery(function ($) {

  // Keep Select2 in sync when WooCommerce rebuilds variation option markup.
  const $variation_form = $('form.variations_form.cart');
  if ($variation_form.length) {
    let seriesContextRequest = null;
    let lastSeriesContextFormat = $('[data-product-related-products]').data('selected-format') || '';

    const refreshVariationSelect2 = () => {
      $variation_form.find('.variations select').each(function () {
        const $select = $(this);
        const value = $select.val();

        $select.find('option').prop('selected', false).removeAttr('selected');
        if (value) {
          $select.find('option').filter(function () {
            return $(this).val() === value;
          }).prop('selected', true);
        }

        ThemeJS.Functions.init_select2(this, true);
      });
    };

    const getSelectedFormat = (variation) => {
      if (variation && variation.attributes && variation.attributes.attribute_pa_format) {
        return variation.attributes.attribute_pa_format;
      }

      return $variation_form.find('[name="attribute_pa_format"]').val() || '';
    };

    const refreshSeriesContext = (format) => {
      format = format || '';

      if (!format || format === lastSeriesContextFormat) {
        return;
      }

      const productId = $variation_form.find('[name="product_id"]').val();
      const $seriesLink = $('[data-product-series-link]');
      const $relatedProducts = $('[data-product-related-products]');
      const ajaxConfig = ThemeJS && ThemeJS.Variables ? ThemeJS.Variables.Ajax : null;

      if (!productId || !ajaxConfig || (!$seriesLink.length && !$relatedProducts.length)) {
        return;
      }

      if (seriesContextRequest) {
        seriesContextRequest.abort();
      }

      seriesContextRequest = $.ajax({
        url: ajaxConfig.url,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'flutterbee_product_series_context',
          nonce: ajaxConfig.nonce,
          product_id: productId,
          format: format || '',
        },
      }).done(function (response) {
        if (!response || !response.success || !response.data) {
          return;
        }

        if ($seriesLink.length) {
          $seriesLink.html(response.data.series_link_html || '');
        }

        if ($relatedProducts.length) {
          $relatedProducts.html(response.data.related_html || '');
          $relatedProducts.attr('data-selected-format', format);
          $(document).trigger('flutterbee:bulk-select-refresh');
        }

        lastSeriesContextFormat = format;
      }).always(function () {
        seriesContextRequest = null;
      });
    };

    $variation_form.on('woocommerce_update_variation_values', refreshVariationSelect2);
    $variation_form.on('reset_data', refreshVariationSelect2);
    $variation_form.on('found_variation', function (event, variation) {
      refreshSeriesContext(getSelectedFormat(variation));
    });
    $variation_form.on('reset_data', function () {
      refreshSeriesContext(getSelectedFormat());
    });

    $variation_form.on('select2:clear', '.variations select', function () {
      $(this).find('option').prop('selected', false).removeAttr('selected');
    });
  }

});
